import { observer } from 'mobx-react';
import React from 'react';
import { RouteComponentProps, StaticContext, withRouter } from 'react-router';
import { withOrderStore } from '../OrderScreen/context';
import OrderContentLogsList from './containers/OrderContentLogsList/OrderContentLogsList';
import { localeStore } from 'src/mobx/localesStore';
import CustomModalComponent from 'src/view/components/Controls/Modal/Modal';
import ModalBackground from 'src/view/components/Controls/Modal/ModalBackground/ModalBackground';
import ModalHeader from 'src/view/components/Controls/Modal/ModalHeader/ModalHeader';
import { OrderStore } from '~/mobx/orderStore';
import getOrderViewPath from '~/view/screens/CheckoutScreen/getOrderViewPath';

export interface IOrderContentLogProps extends RouteComponentProps<{ id: string }, StaticContext, undefined> {
  onClose?: () => void;
  orderStore?: OrderStore;
}

// @ts-ignore
@withOrderStore
@observer
class OrderContentLog extends React.Component<IOrderContentLogProps> {
  get orderStore() {
    return this.props.orderStore!;
  }

  handleClose = () => {
    if (typeof this.props.onClose === 'function') {
      this.props.onClose();
      return;
    }

    this.props.history.push(getOrderViewPath(this.orderStore.parentStore, this.props.match.params.id));
  };

  public render() {
    return (
      <CustomModalComponent withCloseIcon isOpen onRequestClose={this.handleClose}>
        <ModalBackground>
          <ModalHeader title={localeStore.t('order_content_log')} />
          <OrderContentLogsList />
        </ModalBackground>
      </CustomModalComponent>
    );
  }
}

export default withRouter(OrderContentLog);
